(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-main-product")) {
  customElements.define(
    "s-main-product",
    class SectionMainProduct extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.updateVariables();

        this.sectionId = this.dataset.sectionId;
        this.contentWrapper = this.querySelector(".js-main-product__content");

        this.variantPickerUnsubscriber = window.PubSub.subscribe(
          "variant-change",
          (variantId) => {
            this.sectionUpdater(variantId);
          }
        );
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.checkHeightContent);
        this.button?.removeEventListener("click", this.textOpener);
        this.variantPickerUnsubscriber();
      }

      sectionUpdater = (variantId) => {
        let updateURL = false;
        document
          .querySelectorAll(".c-variant-picker__list input")
          .forEach((input) => {
            if (input.value === variantId[0]) {
              updateURL = true;
            }
          });


        if (updateURL) {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set("variant", variantId);

          const newSearch = "?" + searchParams.toString();

          history.pushState({}, "", window.location.pathname + newSearch);
        }

        this.updateProductFromURL();
      };

      updateProductFromURL = () => {
        const url = new URL(window.location.href);
        url.searchParams.set("section_id", this.sectionId);

        fetch(url.toString())
          .then((response) => response.text())
          .then((newHTML) => {
            const newDom = new DOMParser().parseFromString(
              newHTML,
              "text/html"
            );

            if (document.querySelector(".gpo-container")) {
              const newContentWrapper = newDom.querySelector(
                ".js-main-product__content"
              );

              const currentPriceContainer = this.contentWrapper.querySelector(
                ".s-main-product__price-container"
              );
              const currentVariantPicker = this.contentWrapper.querySelector(
                "c-variant-picker .c-variant-picker__cell"
              );
              const currentVariantIdInput =
                this.contentWrapper.querySelector('input[name="id"]');

              const newPriceContainer = newContentWrapper.querySelector(
                ".s-main-product__price-container"
              );
              const newVariantPicker = newContentWrapper.querySelector(
                "c-variant-picker .c-variant-picker__cell"
              );
              const newVariantIdInput =
                newContentWrapper.querySelector('input[name="id"]');

              if (newPriceContainer && currentPriceContainer) {
                currentPriceContainer.innerHTML = newPriceContainer.innerHTML;
              }
              if (newVariantPicker && currentVariantPicker) {
                currentVariantPicker.innerHTML = newVariantPicker.innerHTML;
              }
              if (newVariantIdInput && currentVariantIdInput) {
                currentVariantIdInput.value = newVariantIdInput.value;
              }
            } else {
              this.contentWrapper.innerHTML = newDom.querySelector(
                ".js-main-product__content"
              ).innerHTML;
            }

            this.updateProductMedia();
            this.updateVariables();
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      };

      updateProductMedia = () => {
        const mediaComponent = document.querySelector("c-product-media");
        mediaComponent?.updateProductMedia();
      };

      updateVariables = () => {
        window.removeEventListener("resize", this.checkHeightContent);
        this.button?.removeEventListener("click", this.textOpener);

        this.description = this.querySelector(".js-main-product__description");
        this.wrapper = this.querySelector(
          ".js-main-product__description-wrapper"
        );
        this.wrapperBg = this.querySelector(".js-main-product__description-bg");
        this.button = this.querySelector(".js-main-product__btn-opener");

        this.checkHeightContent();
        window.addEventListener("resize", this.checkHeightContent);
        this.button?.addEventListener("click", this.textOpener);
      };

      checkHeightContent = () => {
        if (this.wrapper) {
          this.wrapper.classList.remove("is-open");

          if (this.wrapper.classList.contains("is-open")) {
            this.button.innerHTML = this.button?.dataset.lessText;
          } else {
            this.button.innerHTML = this.button?.dataset.moreText;
          }

          if (this.wrapper.offsetHeight < this.description.offsetHeight) {
            this.wrapperBg.classList.remove("is-hide");
            this.button.classList.remove("is-hide");
          } else {
            this.wrapperBg.classList.add("is-hide");
            this.button.classList.add("is-hide");
          }
        }
      };

      textOpener = () => {
        this.wrapper.classList.toggle("is-open");

        if (this.wrapper.classList.contains("is-open")) {
          this.button.innerHTML = this.button.dataset.lessText;
        } else {
          this.button.innerHTML = this.button.dataset.moreText;
        }
      };
    }
  );
}

},{}]},{},[1])

